module.exports = __webpack_public_path__ + "media/app/img/unity-logo128-81ddcf528bbe74b66fa18710b89a39ec.png";